import React from "react";

export default [
  {
    target: '.learn-mode-procedure h3',
    placement: 'top',
    styles: {
      options: {
        width: 800
      }
    },
    disableBeacon: true,
    title: 'Bar Regulation helps you get the most range and responsiveness from your EM1.',
    content: (
      <div>
        <p>In EM1 Bar Regulation mode, you will be guided through logging the input of <strong>5 soft</strong> and <strong>5 hard</strong> strikes on all bar sensors including those covered by Gap Caps.</p>
        <p>By default, <strong>Auto Mode</strong> allows you to run through all sensors sequentially. you may also select individual sensors (<strong>Single Note Mode</strong>) by de-selecting Auto-Mode or clicking on a bar.</p>
        <p>For the best results, it is crucial that you strike a bar as lightly as possible for soft strikes, while hard strikes should reflect the loudest you would play the instrument with mallets.</p>
        <p><strong>Do not use fingers or non-standard implements.</strong></p>
      </div>
    )
  },
  {
    target: '.step-1',
    title: 'Select a Bar',
    content: (
      <div>
        <p>(Single Note Mode)</p>
        <p>Identify the bar on the EM1 that is targeted for Regulation, then click on that bar on the Regulation screen. Bars are numbered chromatically 1-43.</p>
        <p><strong>* In Auto Mode, the bars are selected for you automatically.</strong></p>
      </div>
    ),
    placement: 'top',
    disableBeacon: true
  },
  {
    target: '.step-2',
    styles: {
      options: {
        width: 550
      }
    },
    title: 'Select a Strike Type',
    content: (
      <div>
        <p>After selecting an individual bar sensor or selecting Auto Mode, you may choose to start Regulation with Soft or Hard strikes.</p>
        <p>Soft strikes need to be performed by contacting the bars as <strong>gently as possible</strong> while still recording a strike. Hard strikes should be made by striking the key at your maximum strike velocity.</p>
        <p>It may be necessary for you to play more than 5 strikes if the Regulation Program didn't log your strike, this is normal and should not be taken as a motivation to hit a note harder.</p>
        <p>Best results will be achieved with a greater difference between soft and hard strikes.</p>
        <p>Select strike type and press Record to begin.</p>
      </div>
    ),
    placement: 'top',
    disableBeacon: true
  },
  {
    target: '.step-3',
    styles: {
      options: {
        width: 550
      }
    },
    title: 'Record Strikes',
    content: (
      <div>
        <p>Strike the highlighted bar until the Editor records 5 completed strokes (indicated on-screen via a counter displaying 1/5, 2/5, etc). Remember to consistently make the <strong>gentlest possible</strong> contact for soft strikes, as well as your heaviest playing velocity for hard strikes.</p>
        <p><strong>Note</strong>: When recording Soft strikes, it's possible that some strikes may not be registered. It's important to continue to use the <strong>gentlest possible</strong> strike untill all strokes have been recorded.</p>
        <p>If "Use Sounds" is selected (default), an audible tone will indicate the strokes being recorded. Whether in Single Note Mode or in Auto Mode, both soft and hard strikes must be completed, and the bar being played will indicate completion by showing a small "S" or "H".</p>
        <p>Successful completion of strike recording will be indicated by the bar(s) turning green.</p>
      </div>
    ),
    placement: 'top',
    disableBeacon: true
  },
  {
    target: '.step-4',
    title: 'Bar Status',
    content: (
      <div>
        <p>Once the Soft and Hard strikes have been recorded, the editor will calculate the bar adjustments made through the Regulation process.</p>
        <p>A green checkmark ( <span className="green-checkmark">√</span> ) indicates that a bar has completed Bar Regulation.</p>
      </div>
    ),
    placement: 'top',
    disableBeacon: true
  },
  {
    target: '.learn-mode-bar-info',
    styles: {
      options: {
        width: 550
      }
    },
    content: (
      <div>
        <p>Use these to manually adjust a bar <strong>after Bar Regulation</strong> if a bar needs manual adjustments.</p>
        <p><strong>Sensitivity</strong>: Changing this number will alter the general signal strength on the selected bar. The higher the number, the easier it is for velocity to reach 127. Range: 0.01 - 1.99</p>
	      <p><strong>On-Threshold</strong>: Changing this number will affect how easy it is to activate this bar. The higher the number, the harder the strike must be to send a note message. Range: 0.01 - 1.99</p>
      </div>
    ),
    placement: 'right',
    disableBeacon: true
  },
  {
    target: '.learn-mode-settings',
    styles: {
      options: {
        width: 550
      }
    },
    content: (
      <div>
        <p><strong>Auto Mode Toggle</strong>: Selects either Auto or Single Note Regulation Mode.</p>
        <p><strong>Use Sounds Toggle</strong>: Turns strike response tone indicator on or off.</p>
        <p><strong>Export Data</strong>: Outputs a data file (JSON) for analysis of settings and performance.</p>
        <p><strong>Open Tour</strong>: Begins Step-by-Step guidance of Regulation process.</p>
      </div>
    ),
    placement: 'left',
    disableBeacon: true
  },
]
